import { WATCH_TWEETS } from "../actionTypes";

export const watchtweetfeedsfunc = (data) => 
{
    return {
        type: WATCH_TWEETS,
        data: data,
    }
}